import { Form, Formik } from 'formik';
import { Button } from 'primereact/button';
import { useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import useAxiosHook from '../../../../hooks/useAxiosHook';
import {
  generateNotificationsObjectNotify,
  toApiDataNotifications,
} from '../Settings.functions';
import NotificationsForm from './NotificationsForm';

function Notifications() {
  const { t } = useTranslation();
  const formRef = useRef(null);

  const {
    data: defaultNotificationsSubscriptionsData,
    reload: defaultNotificationsSubscriptionsReload,
    isLoading: defaultNotificationsSubscriptionsIsLoading,
  } = useAxiosHook('/notifications/default/subscriptions/carrier');

  const defaultNotificationsValues = useMemo(() => {
    const defaultValues = generateNotificationsObjectNotify(
      t,
      defaultNotificationsSubscriptionsData
    );
    return defaultValues;
  }, [defaultNotificationsSubscriptionsData, t]);
  console.log('defaultNotificationsValues ', defaultNotificationsValues);
  function handleFormSubmission() {
    const fieldsSubs = toApiDataNotifications(
      formRef.current.values,
      'subscriptions'
    );

    defaultNotificationsSubscriptionsReload({
      method: 'POST',
      data: fieldsSubs,
    });
  }

  return (
    <>
      <Formik
        innerRef={formRef}
        initialValues={defaultNotificationsValues}
        enableReinitialize
        onSubmit={handleFormSubmission}
      >
        <Form>
          <NotificationsForm />
        </Form>
      </Formik>
      <div className="button-container">
        <Button
          type="button"
          label={
            defaultNotificationsSubscriptionsIsLoading
              ? t('Loading...')
              : t('Save changes')
          }
          onClick={() => {
            formRef.current.handleSubmit();
          }}
          disabled={defaultNotificationsSubscriptionsIsLoading}
        />

        <Button
          type="button"
          icon="fas fa-sync-alt"
          className="p-button-outlined"
          tooltip={t('Reload settings')}
          onClick={() => {
            formRef.current.resetForm();
            defaultNotificationsSubscriptionsReload();
          }}
        />
      </div>
    </>
  );
}

export default Notifications;
